(() => {
  if (window.__equjumpMenuDrawerLoaded) return;
  window.__equjumpMenuDrawerLoaded = true;

  const getRoot = (element) => element?.closest?.('[data-eq-menu-drawer]');

  const closeDrawer = (root, restoreFocus = true) => {
    if (!root) return;

    const toggle = root.querySelector('[data-eq-menu-open]');
    const panel = root.querySelector('[data-eq-menu-panel]');

    root.classList.remove('is-open');
    toggle?.setAttribute('aria-expanded', 'false');
    toggle?.setAttribute('aria-label', 'Abrir menú');
    panel?.setAttribute('aria-hidden', 'true');

    if (!document.querySelector('[data-eq-menu-drawer].is-open')) {
      document.body.classList.remove('eq-menu-drawer-open');
    }

    if (restoreFocus) {
      window.setTimeout(() => toggle?.focus(), 20);
    }
  };

  const openDrawer = (root) => {
    if (!root) return;

    document.querySelectorAll('[data-eq-menu-drawer].is-open').forEach((openRoot) => {
      if (openRoot !== root) closeDrawer(openRoot, false);
    });

    const toggle = root.querySelector('[data-eq-menu-open]');
    const panel = root.querySelector('[data-eq-menu-panel]');
    const closeButton = root.querySelector('.eq-menu-drawer__close');

    root.classList.add('is-open');
    toggle?.setAttribute('aria-expanded', 'true');
    toggle?.setAttribute('aria-label', 'Cerrar menú');
    panel?.setAttribute('aria-hidden', 'false');
    document.body.classList.add('eq-menu-drawer-open');

    window.setTimeout(() => closeButton?.focus(), 30);
  };

  document.addEventListener(
    'click',
    (event) => {
      const openButton = event.target.closest('[data-eq-menu-open]');

      if (openButton) {
        event.preventDefault();
        event.stopPropagation();

        const root = getRoot(openButton);
        root?.classList.contains('is-open') ? closeDrawer(root) : openDrawer(root);
        return;
      }

      const closeButton = event.target.closest('[data-eq-menu-close]');

      if (closeButton) {
        event.preventDefault();
        event.stopPropagation();
        closeDrawer(getRoot(closeButton));
      }
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openRoot = document.querySelector('[data-eq-menu-drawer].is-open');
    if (openRoot) closeDrawer(openRoot);
  });

  document.addEventListener('shopify:section:unload', () => {
    if (!document.querySelector('[data-eq-menu-drawer].is-open')) {
      document.body.classList.remove('eq-menu-drawer-open');
    }
  });
})();
